export default __webpack_public_path__ + "static/a1_cloud_vision_desktop_banner_bg-e47281628375fd2a3179f02bdd64b16f.webp";